import { useEffect, useState } from 'react';

import CallingCard from '../Components/CallingCard';
import Carousel from '../Components/Carousel';
import { Card } from '../Components/ui';
import BusinessForm from './Partials/FormBusiness';
import PersonalForm from './Partials/FormPersonal';
import LandingPageTabs from './Partials/LandingPageTabs';

import { renderTestimonials } from '../Helpers/renderTestimonials';
import { QUOTE_TYPES } from '../Helpers/surehits';

import landing_page_card_images from '../../../../public/js/landing_page_card_images.json';

const LandingPageForm = () => {
    const isPersonalLines = window.location.pathname.includes('/personal-lines');
    let isPersonalLineActive = window.personal_line_active;
    const auxContent = window.aux_content;
    if (!auxContent.includes('personal_lines')) {
        isPersonalLineActive = false;
    }
    const [formData, setFormData] = useState({
        quoteType: isPersonalLines ? QUOTE_TYPES.PERSONAL : QUOTE_TYPES.BUSINESS,
        quoteOrigin: window.location.pathname,
    });
    const { images } = landing_page_card_images;

    useEffect(() => {
        const useSearchParams = () => {
            const searchParams = new URLSearchParams(window.location.search);
            const params = {};
            for (const [key, value] of searchParams.entries()) {
                params[key] = value;
            }
            return params;
        };
        const keep = ['gclid', 'wbraid', 'gbraid'];
        const params = useSearchParams();
        setFormData(prevData => {
            return {
                ...prevData,
                ...Object.keys(params).reduce((acc, key) => {
                    if (keep.includes(key)) {
                        acc[key] = params[key];
                    }
                    return acc;
                }, {}),
            };
        });
    }, []);
    const showError = false;
    const isCallCenterAvailable = window?.call_center_available ?? true;
    const phone = window?.lead_phone || '';
    const testimonials = window?.testimonials || [];

    return (
        <>
            <div id="landing-form-root">
                <div id="landing-page-form-section">
                    <div id="landing-page-form">
                        <LandingPageTabs
                            isPersonalLines={isPersonalLines}
                            isPersonalLineActive={isPersonalLineActive}
                        />
                        <div className={`form-tab-content${isPersonalLineActive ? ' show-tabs' : ''}`}>
                            <div className="body-1b copy-text">
                                <h4>
                                    Get Started Finding {isPersonalLines ? 'Personal Insurance' : 'Business Insurance'}
                                </h4>
                            </div>
                            <div className="form-wrapper">
                                {isPersonalLines ? (
                                    <PersonalForm useFormData={() => [formData, setFormData, showError]} />
                                ) : (
                                    <BusinessForm useFormData={() => [formData, setFormData, showError]} />
                                )}
                            </div>
                        </div>
                    </div>
                    {isCallCenterAvailable && phone && (
                        <CallingCard phone={phone}>
                            <h5>
                                Want to <span className="text-nowrap">speed-up</span> {'\n'} <p>your quote?</p>
                            </h5>
                            <b className="call">Call us at {phone}</b>
                        </CallingCard>
                    )}
                </div>
            </div>
            <div id="landing-page-card-section">
                <div className="landing-page-cards-container">
                    <Card showContent={true}>
                        <div id="card-images-wrapper">
                            {images.map(({ key, src, width, height }) => (
                                <img
                                    key={key}
                                    src={src}
                                    alt={key}
                                    width={width}
                                    height={height}
                                    className="card-image"
                                    loading="lazy"
                                />
                            ))}
                        </div>
                    </Card>
                    {testimonials.length > 0 && <Carousel content={testimonials} renderItem={renderTestimonials} />}
                </div>
            </div>
        </>
    );
};

export default LandingPageForm;
